import { render, staticRenderFns } from "./BotpressChat.vue?vue&type=template&id=77cfd105&scoped=true&"
import script from "./BotpressChat.vue?vue&type=script&lang=js&"
export * from "./BotpressChat.vue?vue&type=script&lang=js&"
import style0 from "./BotpressChat.vue?vue&type=style&index=0&id=77cfd105&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cfd105",
  null
  
)

export default component.exports